// extracted by mini-css-extract-plugin
export default {"root":"ApprovalTypeStep_root__v10i9"};